import { SelectFilters } from '../../searchableSelect/searchableSelectTypes';
import { getAppliedFilterState } from '../../../helpers/appliedFilterHelper';
import { useTransactionTypeList } from '../../../hooks/useTransactionTypeList';
import { useClearTransactionTypeFilter } from './useClearTransactionTypeFilter';

/** The filter tags `SearchableSelect` shows for a transaction type list, locked and cleared like the picker page's. */
export const useTransactionTypeSelectFilters = (
  transactionTypeList: ReturnType<typeof useTransactionTypeList>,
): SelectFilters => {
  const {
    selectedFilter,
    selectedCategoryFilters,
    categoryFilterOptions,
    disableFilter,
    filterDisabledInfoMessage,
  } = transactionTypeList;
  const clearFilter = useClearTransactionTypeFilter(transactionTypeList);

  const { appliedFilters, isTagLocked, isClearAllDisabled } = getAppliedFilterState({
    selectedFilter: [selectedFilter, ...selectedCategoryFilters],
    checkboxOptions: categoryFilterOptions,
    disableFilter,
  });

  return {
    applied: appliedFilters.map(({ value, label }) => ({
      value,
      label,
      disabled: isTagLocked(value),
    })),
    onRemove: clearFilter,
    onClearAll: () => clearFilter(),
    clearAllDisabled: isClearAllDisabled,
    disabledInfoMessage: filterDisabledInfoMessage,
  };
};
